var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.allowed)?_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary"},on:{"click":_vm.create_item}},[_vm._v(" "+_vm._s(_vm.translate("common.new_item"))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }